// extracted by mini-css-extract-plugin
export default {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","homepageLayout":"_2PH_u","homepageBrandValue":"_3MTAg"};